module.exports = __webpack_public_path__ + "static/img/nutrena.fec81af.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/nutrena.png
// module id = 664
// module chunks = 1